"use strict";
/** @module models */
Object.defineProperty(exports, "__esModule", { value: true });
exports.JoinRequestResponse = exports.JoinRequestResponseStatusEnum = exports.UserJoinRequest = exports.JoinRequest = exports.JoinRequestStatusEnum = void 0;
var cerealParse_1 = require("../cerealParse");
var agency_1 = require("./agency");
var client_1 = require("./client");
var unit_1 = require("./unit");
var JoinRequestStatusEnum;
(function (JoinRequestStatusEnum) {
    JoinRequestStatusEnum[JoinRequestStatusEnum["pending"] = 0] = "pending";
    JoinRequestStatusEnum[JoinRequestStatusEnum["approved"] = 1] = "approved";
    JoinRequestStatusEnum[JoinRequestStatusEnum["denied"] = 2] = "denied";
    JoinRequestStatusEnum[JoinRequestStatusEnum["expired"] = 3] = "expired";
})(JoinRequestStatusEnum || (exports.JoinRequestStatusEnum = JoinRequestStatusEnum = {}));
/**
 * Class representing a join request and providing a static parse method.
 * [Spec](https://gitlab.bryx.com/bryx911/bryx911-spec/blob/master/Models/JoinRequest.md#joinrequest-object)
 */
var JoinRequest = /** @class */ (function () {
    function JoinRequest(id, creationTs, expirationTs, status, unit, requestingClient, message, manager, replyMessage) {
        this.id = id;
        this.creationTs = creationTs;
        this.expirationTs = expirationTs;
        this.status = status;
        this.unit = unit;
        this.requestingClient = requestingClient;
        this.message = message;
        this.manager = manager;
        this.replyMessage = replyMessage;
    }
    /**
     * Parse object potentially representing a JoinREquest.
     * @param o
     * @return Parse result
     */
    JoinRequest.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new JoinRequest(cerealParse_1.ParseUtils.getString(o, 'id'), new Date(cerealParse_1.ParseUtils.getNumber(o, 'creationTs') * 1000), new Date(cerealParse_1.ParseUtils.getNumber(o, 'expirationTs') * 1000), cerealParse_1.ParseUtils.getEnum(o, 'status', JoinRequestStatusEnum), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'units', unit_1.RequestUnit.parse, 'warn')[0], cerealParse_1.ParseUtils.getSubobject(o, 'requestingClient', client_1.RequestClient.parse), cerealParse_1.ParseUtils.getString(o, 'message'), cerealParse_1.ParseUtils.getSubobjectOrNull(o, 'manager', client_1.RequestClient.parse), cerealParse_1.ParseUtils.getStringOrNull(o, 'replyMessage')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid JoinRequest Model: ".concat(e.message));
        }
    };
    /**
     * Compare two JoinRequest instances by their creation times.
     * @param a
     * @param b
     * @return 0 if equal, > 0 if a is older than b, < 0 if a is younger than b
     */
    JoinRequest.compare = function (a, b) {
        return b.creationTs.getTime() - a.creationTs.getTime();
    };
    return JoinRequest;
}());
exports.JoinRequest = JoinRequest;
/**
 * Class representing a user join request and providing a static parse method.
 * [Spec](https://gitlab.bryx.com/bryx911/bryx911-spec/blob/master/Models/JoinRequest.md#userjoinrequest-object)
 */
var UserJoinRequest = /** @class */ (function () {
    function UserJoinRequest(id, agency, creationTs, expirationTs, status, unit, message, manager, replyMessage) {
        this.id = id;
        this.agency = agency;
        this.creationTs = creationTs;
        this.expirationTs = expirationTs;
        this.status = status;
        this.unit = unit;
        this.message = message;
        this.manager = manager;
        this.replyMessage = replyMessage;
    }
    /**
     * Parse object potentially representing a JoinREquest.
     * @param o
     * @return Parse result
     */
    UserJoinRequest.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new UserJoinRequest(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getSubobject(o, 'agency', agency_1.MinimalAgency.parse), new Date(cerealParse_1.ParseUtils.getNumber(o, 'creationTs') * 1000), new Date(cerealParse_1.ParseUtils.getNumber(o, 'expirationTs') * 1000), cerealParse_1.ParseUtils.getEnum(o, 'status', JoinRequestStatusEnum), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'units', unit_1.RequestUnit.parse, 'warn')[0], cerealParse_1.ParseUtils.getString(o, 'message'), cerealParse_1.ParseUtils.getSubobjectOrNull(o, 'manager', client_1.RequestClient.parse), cerealParse_1.ParseUtils.getStringOrNull(o, 'replyMessage')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid UserJoinRequest Model: ".concat(e.message));
        }
    };
    /**
     * Compare two JoinRequest instances by their creation times.
     * @param a
     * @param b
     * @return 0 if equal, > 0 if a is older than b, < 0 if a is younger than b
     */
    UserJoinRequest.compare = function (a, b) {
        return b.creationTs.getTime() - a.creationTs.getTime();
    };
    return UserJoinRequest;
}());
exports.UserJoinRequest = UserJoinRequest;
var JoinRequestResponseStatusEnum;
(function (JoinRequestResponseStatusEnum) {
    JoinRequestResponseStatusEnum[JoinRequestResponseStatusEnum["success"] = 0] = "success";
    JoinRequestResponseStatusEnum[JoinRequestResponseStatusEnum["error"] = 1] = "error";
})(JoinRequestResponseStatusEnum || (exports.JoinRequestResponseStatusEnum = JoinRequestResponseStatusEnum = {}));
/**
 * Class representing join request response and providing a static parse method.
 */
var JoinRequestResponse = /** @class */ (function () {
    function JoinRequestResponse(id, status, reason) {
        this.id = id;
        this.status = status;
        this.reason = reason;
    }
    /**
     * Parse object potentially representing a JoinRequestResponse.
     * @param o
     * @return Parse result
     */
    JoinRequestResponse.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new JoinRequestResponse(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getEnum(o, 'status', JoinRequestResponseStatusEnum), cerealParse_1.ParseUtils.getStringOrNull(o, 'reason')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid JoinRequestResponse Model: ".concat(e.message));
        }
    };
    return JoinRequestResponse;
}());
exports.JoinRequestResponse = JoinRequestResponse;
//# sourceMappingURL=joinRequest.js.map